/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qr_Warehouse_TitleInputs */

const vi_qr_warehouse_title = /** @type {(inputs: Qr_Warehouse_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét QR xuất kho`)
};

/**

* @param {Qr_Warehouse_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const qr_warehouse_title = /** @type {((inputs?: Qr_Warehouse_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qr_Warehouse_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_qr_warehouse_title(inputs)
});